export const OPEN_COOKIE_PREFERENCES_EVENT = 'wetree:open-cookie-preferences';

export function openCookiePreferences(): void {
  window.dispatchEvent(new Event(OPEN_COOKIE_PREFERENCES_EVENT));
}
